<div *transloco="let t; read: 'profile-list-search'"
  class="search-container"
  role="region"
  [attr.aria-label]="t('aria_search_box')">
  <div class="input-wrapper">
    <accredible-text-input [ariaLabel]="t('aria_search_term')"
      [formControlRef]="searchFormControl"
      (keydown.enter)="onChangeSearchCriteria(searchFormControl.value)"
      [placeholder]="currentPlaceholder"
      [icon]="'icon-search'"
      [noError]="true"/>

    @if (searchByOptions().length > 0) {
      <div class="divider"></div>
      <accredible-select-input [formControlRef]="searchByFormControl"
        [ariaLabel]="t('aria_search_by')"
        [hideLabel]="true"
        [label]="t('aria_search_by')"
        [options]="searchByOptions()"
        [noErrorMargin]="true"/>
    }
  </div>
</div>
